// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media screen and (max-width:768px){.QPId1{background-color:#fff}}@media screen and (min-width:768px){.QPId1.iy0o\\+{max-width:652px;margin:0 auto}}@media screen and (min-width:1024px){.QPId1.iy0o\\+{max-width:980px}}@media screen and (min-width:1236px){.QPId1.iy0o\\+{padding-left:24px;padding-right:24px}}@media screen and (min-width:1552px){.QPId1.iy0o\\+{max-width:1296px}}._2uh6F{display:flex;flex-flow:wrap;align-items:center;justify-content:space-between;padding:24px 16px;grid-gap:16px;gap:16px}@media screen and (min-width:768px){._2uh6F{padding:0 0 24px}}.hV6xw{display:inline;margin:0;font-family:\"Merriweather\",serif;font-size:26px;font-weight:700;line-height:30px}@media screen and (min-width:768px){.hV6xw{font-size:36px;line-height:44px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": "QPId1",
	"withoutSidebar": "iy0o+",
	"header": "_2uh6F",
	"title": "hV6xw"
};
module.exports = ___CSS_LOADER_EXPORT___;
